export const APPLY_PATCH_TOPIC = '/user/topic/patch';
export enum ApplyPatchMessages {
  ApplyPatch = 'ApplyPatch',
}
